<template>
  <div id="modal-info">
    <button type="button" @click="modalShow = true">
      <i class="icofont-question"></i>
    </button>
    <b-modal
      v-model="modalShow"
      hide-footer
      centered
      scrollable
      ref="modal"
      id="modal-info-body"
      size="xl"
    >
      <template #modal-header>
        <div class="d-flex justify-content-between w-100">
          <div class="modal-info-accessibility">
            <ul>
              <li>
                <a
                  href=""
                  title="Aumentar fonte"
                  v-on:click.prevent.stop="aumentarFonte()"
                  >A+</a
                >
              </li>
              <li>
                <a
                  href=""
                  title="Diminuir fonte"
                  v-on:click.prevent.stop="diminuirFonte()"
                  >A-</a
                >
              </li>
            </ul>
          </div>

          <span @click="modalShow = false">
            <i class="icofont-close" style="cursor: pointer"></i>
          </span>
        </div>
      </template>
      <div>
        <h2>Relatório atendimentos</h2>

        <p>
          Este relatório apresenta quantitativos de Atendimentos, Procedimentos,
          Vacinas ou Visitas Domiciliares por profissional de saúde realizados
          nos últimos 90 dias corridos a contar da data de hoje para trás.
        </p>

        <h3>FUNCIONALIDADES</h3>

        <p>
          Quando selecionado uma Unidade de Saúde na
          <strong>caixa de seleção UBS</strong>, o sistema vai buscar os dados
          relacionados a ela. Com as informações em tela,
          <strong>pode-se filtrar na caixa de seleção Equipe</strong> e ficam
          exibidos somente os profissionais de saúde vinculados, exclusivamente,
          ao INE da Equipe selecionada.
        </p>

        <p>
          <strong>Atenção:</strong> Para usar o filtro
          <strong>selecionar Equipe</strong>, antes precisa ter uma UBS
          selecionada.
        </p>

        <h3>Detalhamento do quantitativo de atendimentos</h3>

        <p>
          <span
            >Clicando no botão <strong>DETALHAR</strong>, que fica na
            <strong>coluna AÇÃO</strong> da tabela é possível visualizar:</span
          >
        </p>

        <ul>
          <li><strong>Nome do profissional</strong> de saúde;</li>
          <li>
            <strong>Fonte</strong> - que mostra de onde veio os dados (e-SUS
            PEC) e a data em que os dados chegaram aqui no sistema.
            <strong
              >Se a data aqui for menor que a data de hoje, então deve-se
              comunicar ao Administrador Municipal do e-SUS PEC ou Centralizador
              para verificar se os dados foram processados e enviados para o
              SISAB;</strong
            >
          </li>
          <li>
            <strong>Quantidade de atendimentos</strong>, procedimentos, vacinas
            ou visitas domiciliares realizadas nos últimos 90 dias. Essa
            informação depende da função do profissional que está sendo
            selecionado. Na seção de FONTE DOS DADOS, tem mais detalhes;
          </li>
          <li>
            O <strong>botão PDF</strong> permite baixar os dados de acordo com o
            filtro aplicado;
          </li>
        </ul>

        <p>
          Se desejar, você pode informar uma <strong>Data início</strong>, uma
          <strong>Data Fim</strong> e clicar em <strong>FILTRAR</strong> para
          ver os dados de um período menor que os últimos 90 dias. Ao clicar no
          <strong>botão LIMPAR</strong>, serão exibidos novamente os últimos 90
          dias de dados.
        </p>

        <p>
          <strong>Atenção:</strong> Ainda não é possível buscar quantitativos de
          dados em períodos anteriores aos últimos 90 dias. Se você tem essa
          necessidade, então por gentileza, envia ao suporte que a equipe de
          desenvolvimento analisa a viabilidade.
        </p>

        <h3>FONTE DOS DADOS</h3>

        <p>
          Os quantitativos apresentados no relatório referentes aos
          <strong
            >médicos, enfermeiros, odontólogos e outros profissionais de nível
            superior</strong
          >
          são provenientes dos registros realizados:
        </p>

        <ul>
          <li>No SOAP, pelo uso do e-SUS PEC; ou</li>
          <li>Na Ficha de Atendimento Individual do CDS; ou</li>
          <li>Na Ficha de Atendimento Odontológico Individual do CDS; ou</li>
          <li>
            Em sistemas próprios ou de terceiros e importados os registros no
            e-SUS PEC Centralizador.
            <strong
              >Deve-se garantir que as informações foram importadas com sucesso
              no e-SUS PEC Centralizador.</strong
            >
          </li>
        </ul>
        <p>
          Os quantitativos apresentados no relatório referentes aos
          <strong>ACS</strong> são provenientes dos registros realizados:
        </p>
        <ul>
          <li>
            No a aplicativo e-SUS Território, mas especificamente, pelo
            preenchimento da Ficha de Visita individual ou Visita Domiciliar.
            <strong
              >Deve-se garantir que a sincronização do aplicativo com o servidor
              do e-SUS PEC ou Centralizador foi realizada com sucesso;</strong
            >
            ou
          </li>
          <li>Na Ficha de Visita Domiciliar e Territorial do CDS; ou</li>
          <li>
            Em aplicativos ou sistemas próprios ou de terceiros e importados os
            registros no e-SUS PEC Centralizador.
            <strong
              >Deve-se garantir que as informações foram importadas com sucesso
              no e-SUS PEC Centralizador.</strong
            >
          </li>
        </ul>

        <p>
          Os quantitativos apresentados no relatório referentes aos
          <strong>Técnicos ou Auxiliares de Enfermagem</strong> são provenientes
          dos registros realizados:
        </p>

        <ul>
          <li>
            No SOAP, Escuta Inicial ou Pré-Atendimento, pelo uso do e-SUS PEC;
            ou
          </li>
          <li>No registro de Vacinação pelo e-SUS PEC; ou</li>
          <li>Ficha de vacinação do CDS; ou</li>
          <li>
            No aplicativo e-SUS Vacinação.
            <strong
              >Deve-se garantir que a sincronização do aplicativo com o servidor
              do e-SUS PEC ou Centralizador foi realizada com sucesso;</strong
            >
            ou
          </li>
          <li>
            Em sistemas próprios ou de terceiros e importados os registros no
            e-SUS PEC Centralizador.
            <strong
              >Deve-se garantir que as informações foram importadas com sucesso
              no e-SUS PEC Centralizador.</strong
            >
          </li>
        </ul>
        <h3>RELATÓRIOS RELACIONADOS</h3>
        <p>
          <span
            >As Visitas Individuais, Domiciliares e Territoriais são base para
            gerar os relatórios: </span
          ><strong
            ><span
              >Relatório atendimentos quando analisado o ACS, Cidadãos
              Visitados, Famílias Visitadas, Desempenho por microárea e Envio
              APP ACS PEC</span
            ></strong
          ><span>.</span>
        </p>
        <p>&nbsp;</p>
        <blockquote>
          <p>
            <strong><span>ATENÇÃO</span></strong>
          </p>
          <p>
            <span
              >Esses relatórios são diferentes entre si, então a comparação de
              quantidade entre eles, naturalmente, vai ser diferente também.
              Para interpretar corretamente os números de cada relatório,
              recomenda-se realizar a leitura do artigo relacionado a cada um,
              clicando no botão (?) ajuda.</span
            >
          </p>
        </blockquote>
        <p>&nbsp;</p>
        <p>
          <span>No </span><strong><span>Relatório de atendimento</span></strong
          ><span
            >, quando analisada a produção do ACS, então está visualizando-se
            todas as visitas registradas em indivíduos nos últimos 90 dias. São
            consideradas todas as fichas de visitas registradas no período
            (Visitas realizadas, Visitas ausentes e Visitas recusadas).</span
          >
        </p>
        <p>
          <span>Em </span><strong><span>Cidadãos visitados</span></strong
          ><span>, visualiza-se a </span
          ><strong><span>última ficha de visita individual</span></strong
          ><span> registrada para cada cidadão nos últimos 5 meses. Na </span
          ><strong><span>Lista nominal e Resultado</span></strong
          ><span
            >, são consideradas todas as fichas de visitas registradas em
            cidadãos presentes no território no período (Visitas realizadas,
            Visitas ausentes e Visitas recusadas), onde é possível filtrar pelo
            Status da Visita.</span
          >
        </p>
        <p>
          <span>Para a intepretação de </span
          ><strong><span>Famílias visitadas</span></strong
          ><span>, acompanha-se pelo nome do responsável familiar a </span
          ><strong><span>visita mais recente registrada</span></strong
          ><span> para algum membro da família nos últimos 5 meses. Na </span
          ><strong><span>Lista nominal e Resultado</span></strong
          ><span
            >, são consideradas todas as fichas de visitas registradas em
            cidadãos presentes no território no período (Visitas realizadas,
            Visitas ausentes e Visitas recusadas).</span
          >
        </p>
        <p>
          <span>Para o </span
          ><strong><span>Desempenho por microárea</span></strong
          ><span>, analisa-se a a </span
          ><strong><span>última ficha de visita individual</span></strong
          ><span>
            (Visitas realizadas, Visitas ausentes e Visitas recusadas)
            registrada para cada cidadão no período selecionado.</span
          >
        </p>
        <p>
          <span>O relatório </span
          ><strong><span>Envio APP ASC PEC</span></strong
          ><span
            >, analisa-se todas as Fichas de Visitas Individuais e Familiares
            (Visitas realizadas, Visitas ausentes e Visitas recusadas) feitas
            pelos ACS e registradas ou enviadas ao e-SUS PEC ou Centralizador
            nos últimos 30 dias.</span
          >
        </p>
        <p>&nbsp;</p>
        <p>
          <strong
            ><span>Comparação dos resultados entre os relatórios</span></strong
          >
        </p>
        <p>
          <span
            >Para interpretar corretamente os relatórios, é necessário entender
            a diferença entre a quantidade de fichas de visitas produzidas e
            registradas pelo Agente Comunitário de Saúde e a quantidade de
            cidadãos visitados no período.</span
          >
        </p>
        <p>
          <span
            >Por exemplo, em um período de 30 dias, o ACS pode registrar 100
            fichas de visitas individuais, porém somente visitou 70 cidadãos,
            devido ao fato de que alguns cidadãos receberam mais de uma visita
            no período. Portanto, é correto afirmar que existem 100 fichas de
            visitas domiciliares e territoriais registradas no sistema e-SUS PEC
            ou Centralizador, bem como houve a visita a somente 70 cidadãos no
            mesmo período.</span
          >
        </p>
        <p>
          <span>Assim, entende-se que os relatórios: </span
          ><strong><span>Envio APP ACS PEC</span></strong
          ><span> e </span><strong><span>Relatório de atendimento</span></strong
          ><span>, que contam </span
          ><strong
            ><span>quantidade de fichas de visitas registradas</span></strong
          ><span>
            ou enviadas ao e-SUS PEC ou Centralizador, irão apresentar
            quantidades diferentes dos relatórios: </span
          ><strong><span>Cidadãos visitados, Famílias visitadas</span></strong
          ><span> e </span><strong><span>Desempenho por microárea</span></strong
          ><span
            >, que contam a quantidade de cidadãos que receberam uma ou mais
            visitas no período analisado.</span
          >
        </p>
        <p>&nbsp;</p>
        <blockquote>
          <p>
            <strong><span>ATENÇÃO</span></strong>
          </p>
          <p>
            <span
              >Vale salientar que para realizar a comparação entre esses
              relatórios relacionados, deve-se observar o mesmo período de
              tempo.</span
            >
          </p>
        </blockquote>
        <p>&nbsp;</p>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'SectionTitle',
  components: {},
  props: {},
  data() {
    return {
      modalShow: false,
    }
  },
  methods: {
    /**
     * Aumentar tamanho da fonte
     */
    aumentarFonte() {
      let elements = document
        .querySelector('#modal-info-body')
        .querySelectorAll('*')
      let fonts = []

      function getFontSize() {
        for (let i = 0; i < elements.length; i++) {
          let fontSize = window
            .getComputedStyle(elements[i], null)
            .getPropertyValue('font-size')
          fonts.push(parseFloat(fontSize))
        }
      }

      getFontSize()

      for (let i = 0; i < elements.length; i++) {
        ++fonts[i]
        elements[i].style.fontSize = fonts[i] + 'px'
      }
    },

    /**
     * Diminuir tamanho da fonte
     */
    diminuirFonte() {
      let elements = document
        .querySelector('#modal-info-body')
        .querySelectorAll('*')
      let fonts = []

      function getFontSize() {
        for (let i = 0; i < elements.length; i++) {
          let fontSize = window
            .getComputedStyle(elements[i], null)
            .getPropertyValue('font-size')
          fonts.push(parseFloat(fontSize))
        }
      }

      getFontSize()

      for (let i = 0; i < elements.length; i++) {
        --fonts[i]
        elements[i].style.fontSize = fonts[i] + 'px'
      }
    },
  },
}
</script>

<style scoped>
#modal-info {
  flex: 0 1 33%;
}

#modal-info button {
  width: 35px;
  height: 35px;
  border-radius: 32px;
  display: inline-block;
  background-color: #0fafd7;
  color: #fff;
  font-weight: 700;
  text-align: center;
  text-transform: uppercase;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2),
    0 1px 5px 0 rgba(0, 0, 0, 0.12);
  margin-top: 0;
  float: right;
}

#modal-info-body h2 {
  font-size: 18px;
  text-align: center;
  font-weight: bold;
}

#modal-info-body h3 {
  font-size: 14px;
  font-weight: bold;
  margin: 20px 0;
}

#modal-info-body p {
  font-size: 14px;
  text-align: justify;
  margin-bottom: 0;
}

#modal-info-body ul {
  margin: 10px 25px 10px 25px;
  list-style-type: disc;
}

#modal-info-body ul li {
  font-size: 14px;
}

.modal-info-accessibility ul {
  display: inline-flex;
  margin: 10px 0 !important;
  padding: 0;
  gap: 5px;
}

.modal-info-accessibility ul li {
  border: 1px solid;
  list-style-type: none;
  padding: 5px;
  width: 30px;
  text-align: center;
  background-color: #6c757d;
  border-color: #6c757d;
  border-radius: 3px;
}

.modal-info-accessibility ul li a {
  color: #fff;
  font-size: 14px;
}

.modal-info-accessibility ul li a:hover {
  color: #000;
}
</style>
